import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import { AuthCallback, ProtectedRoute } from "./components/AuthComponents";
import { LoginPage, RegisterPage } from "./pages/AuthPages";
import LandingPage from "./pages/LandingPage";
import DashboardPage from "./pages/DashboardPage";
import MentorPage from "./pages/MentorPage";
import SettingsPage from "./pages/SettingsPage";
import SubscriptionPage from "./pages/SubscriptionPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import ImpressumPage from "./pages/ImpressumPage";
import AGBPage from "./pages/AGBPage";
import DatenschutzPage from "./pages/DatenschutzPage";
import SupportPage from "./pages/SupportPage";
import StrategiesPage from "./pages/StrategiesPage";
import KnowledgeBasePage from "./pages/KnowledgeBasePage";
import { Toaster } from "./components/ui/sonner";
import CookieConsent from "./components/CookieConsent";
import KnowledgeBaseAnnouncement from "./components/KnowledgeBaseAnnouncement";

// Router wrapper to check for session_id in URL hash
const AppRouter = () => {
  const location = useLocation();
  
  // Check URL fragment for session_id (Google OAuth callback)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/impressum" element={<ImpressumPage />} />
      <Route path="/agb" element={<AGBPage />} />
      <Route path="/datenschutz" element={<DatenschutzPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route 
        path="/dashboard" 
        element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/strategies" 
        element={
          <ProtectedRoute>
            <StrategiesPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/wissensdatenbank" 
        element={
          <ProtectedRoute>
            <KnowledgeBasePage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/mentor" 
        element={
          <ProtectedRoute>
            <MentorPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/settings" 
        element={
          <ProtectedRoute>
            <SettingsPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/admin/dashboard" 
        element={
          <ProtectedRoute>
            <AdminDashboardPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/support" 
        element={
          <ProtectedRoute>
            <SupportPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/subscription" 
        element={
          <ProtectedRoute>
            <SubscriptionPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/subscription/success" 
        element={
          <ProtectedRoute>
            <SubscriptionPage />
          </ProtectedRoute>
        } 
      />
    </Routes>
  );
};

function App() {
  return (
    <div className="App dark">
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <AppRouter />
            <CookieConsent />
            <KnowledgeBaseAnnouncement />
          </BrowserRouter>
          <Toaster />
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
